import React, { useEffect, useState } from 'react';
import axios from 'axios';

const Transaction = () => {
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const baseUrl = `${process.env.REACT_APP_API_URL}/transaction`;

  useEffect(() => {
    const fetchTransactions = async () => {
      try {
        const response = await axios.get(baseUrl);
        setTransactions(response.data);
      } catch (err) {
        setError('Failed to fetch transactions.');
      } finally {
        setLoading(false);
      }
    };

    // fetchTransactions();
  }, [baseUrl]);

  if (loading) return <div className="text-center mt-4 text-blue-500">Loading...</div>;

  return (
    <div className="max-w-12xl mx-auto p-4">
      <h2 className="text-2xl font-bold mb-4">Transactions</h2>
      <div className="overflow-x-auto bg-white shadow-md rounded">
        <table className="min-w-full table-auto text-sm">
          <thead className="bg-gray-100">
            <tr>
              <th className="px-4 py-2 text-left">Pair</th>
              <th className="px-4 py-2 text-left">Amount</th>
              <th className="px-4 py-2 text-left">Order Price</th>
              <th className="px-4 py-2 text-left">Token In</th>
              <th className="px-4 py-2 text-left">Token Out</th>
              <th className="px-4 py-2 text-left">Status</th>
              <th className="px-4 py-2 text-left">Filled At</th>
              <th className="px-4 py-2 text-left">Tx Hash</th>
            </tr>
          </thead>
          <tbody>
            {transactions.map((tx) => (
              <tr key={tx._id} className="border-t hover:bg-gray-50">
                <td className="px-4 py-2">{tx.pair}</td>
                <td className="px-4 py-2">{tx.amount}</td>
                <td className="px-4 py-2">${Number(tx.orderPrice).toFixed(2)}</td>
                <td className="px-4 py-2">{tx.tokenIn}</td>
                <td className="px-4 py-2">{tx.tokenOut}</td>
                <td className="px-4 py-2">{tx.status}</td>
                <td className="px-4 py-2">
                  {new Date(tx.filledAt).toLocaleString()}
                </td>
                <td className="px-4 py-2 break-all text-blue-600">{tx.transactionHash}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Transaction;
